export const DEFAULT_COMPONENT_PAGINATION_GAP = 12;
